import { render, staticRenderFns } from "./RealtimeTransferAppealDialog.vue?vue&type=template&id=a93e4286&scoped=true"
import script from "./RealtimeTransferAppealDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RealtimeTransferAppealDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "@/assets/scss/pages/setting.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "./RealtimeTransferAppealDialog.vue?vue&type=style&index=2&id=a93e4286&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93e4286",
  null
  
)

export default component.exports